<div *ngIf="!useAntInput; else antInput" data-e2e="search-field" class="ui icon input" [class.loading]="isSearching" [class.disabled]="disabled">
  <input data-e2e="search-input" type="text" #inputEle naturalNumbersOnlyInput [attr.placeholder]="placeholder" [ngModel]="currentValue" (ngModelChange)="updateCurrentValue($event)">
  <i class="icon auto-pointer">
    <span [hidden]="isSearching">
      <span [hidden]="currentValue && currentValue.length > 0"> <svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.97 25.93"><path fill="#757575" d="M25.68 24.24l-6.22-6.23a11 11 0 1 0-1.4 1.39l6.22 6.24a1 1 0 1 0 1.39-1.4zM11 19.93a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"/></svg></span>
      <span [hidden]="!currentValue"><button data-e2e="clear-search" class="action" (click)="removeValue()"> <svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg> </button></span>
    </span>
  </i>
</div>
<ng-template #antInput>
  <div>
    <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="currentValue && suffixIconClose">
      <input #inputEle type="text" nz-input [attr.placeholder]="placeholder" [ngModel]="currentValue" (ngModelChange)="updateCurrentValue($event)" [disabled]="isSearching || disabled"/>
    </nz-input-group>
    <ng-template #prefixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
    <ng-template #suffixIconClose>
      <i nz-icon nzType="close" class="action" (click)="removeValue()"></i>
    </ng-template>
  </div>
</ng-template>

